import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the PWA service worker (production-only, avoids stale caches during dev)
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.info("[Tyvena] Service worker registered:", reg.scope);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[Tyvena] Service worker registration failed:", err);
      });
  });
}
